import React, { useEffect } from 'react'
import QuestionComponentProps from '../../Questions/question-component-props'
import { AppFormEventParams } from '../../services/events-service'
import { useQuestionVisibilityTracking } from '../../hooks/useQuestionVisibilityTracking'

type WithQuestionExtraProps = {
  eventsServiceUrl?: string
  appFormEventParams?: AppFormEventParams
}

const withQuestion =
  <P extends QuestionComponentProps & WithQuestionExtraProps>(WrappedComponent: React.ComponentType<P>) =>
  (props: QuestionComponentProps & WithQuestionExtraProps): JSX.Element => {
    const { eventsServiceUrl, appFormEventParams, ...rest } = props

    useQuestionVisibilityTracking(props.questionKey, { eventsServiceUrl, appFormEventParams })

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    return <WrappedComponent {...({ ...rest, eventsServiceUrl, appFormEventParams } as P)} />
  }

export default withQuestion
